enum Language {
  english = 'English',
  ukrainian = 'Українська',
  spanish = 'Español',
  french = 'Français',
}

export default Language
